import { useState, useEffect } from "react";
import { useFirebaseWishesDataFetch } from "../contexts/FirebaseConnectionContext";
import { useModalContext } from "../contexts/ModalContext";
import HeaderShadowSeparator from "../components/parts/separator/HeaderShadowSeparator";
import PagesHeader from "../components/header/pagesHeader/PagesHeader";
import SearchWishesBar from "../components/wishes/SearchWishesBar";
import Modal from "../components/modal/Modal";
import OpenAddWishModalButton from "../components/wishes/OpenAddWishModalButton";
import OpenShareWishesListButton from "../components/wishes/OpenShareWishesListButton";
import WishCard from "../components/wishes/WishCard";
import { sortAlphabetically, sortCheapestFirst, sortExpensiveFirst } from "../utils/helper";
import gift from "../assets/images/gift.jpg";

const WishesPage = () => {
  const { giftsList } = useFirebaseWishesDataFetch();
  const { modalState, openWishDataModal } = useModalContext()
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState();
  const [wishesList, setWishesList] = useState();

  const headerContent = (
    <div className="flex justify-between items-center w-full">
      {/* Le i est utilisé pour obtenir le justify-between */}
      <i />
      <h1 className="pagesHeader-title">Mes souhaits</h1>
      <OpenShareWishesListButton giftsList={giftsList} />
    </div>
  )

  useEffect(() => {
    giftsList && setWishesList(
      giftsList.filter(element =>
        element.title.toLowerCase().includes(search.toLowerCase())
      )
    )
  }, [search, giftsList, setWishesList]);

  switch (order) {
    case "alphabetical":
      sortAlphabetically(wishesList);
      break;
    case "cheaper_first":
      sortCheapestFirst(wishesList);
      break;
    case "expensive_first":
      sortExpensiveFirst(wishesList);
      break;
    default:
      break;
  }

  return (
    <main className="main-logged">
      <HeaderShadowSeparator css="bg-ivory" />
      <PagesHeader child={headerContent} />
      <SearchWishesBar setSearch={setSearch} search={search} setOrder={setOrder} />
      <div className="h-[31vh] w-full overflow-y-auto global-px py-3 flex flex-col gap-4 rounded-md font-bold text-darkOrange sm:h-[43vh] md:grid md:auto-rows-min md:grid-cols-2 lg:h-[52vh] lg:grid-cols-3">
        {wishesList && wishesList.map(wish => <WishCard key={wish.id} wishData={wish} openWishDataModal={openWishDataModal} />)}
        <div className=" w-full flexJustifyItemsCenter">
          <OpenAddWishModalButton />
        </div>
      </div>
      {modalState.modalType === "shareList" && <Modal typeModal={modalState.modalType} />}
      {modalState.modalType === "wishData" && <Modal
        typeModal={modalState.modalType}
        imgHeader={[gift, "Un cadeau"]}
        headerTitle={modalState.wishData.title}
      />}
      {modalState.modalType === "addWish" && <Modal
        typeModal={modalState.modalType}
        imgHeader={[gift, "Un cadeau"]}
        headerTitle="Ajouter un souhait"
      />}
    </main>
  );
};

export default WishesPage;